import React, { useCallback, useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';

import usePrevious from 'Hooks/usePrevious';

import CheckEmailStep from './steps/check-email-step/check-email-step';
import EmailStep from './steps/email-step/email-step';
import PasswordStep from './steps/password-step/password-step';

const LoginCarousel = props => {
	const { activeStep, setActiveStep, doTrackContact, captchaEnabled } = props;
	const nextStep = useCallback(() => {
		setActiveStep(activeStep + 1);
	}, [activeStep, setActiveStep]);

	const prevStep = useCallback(() => {
		setActiveStep(activeStep - 1);
	}, [activeStep, setActiveStep]);

	const prevActiveStep = usePrevious(activeStep);

	useEffect(() => {
		if (activeStep && prevActiveStep !== activeStep) {
			doTrackContact();
		}
	}, [activeStep, doTrackContact, prevActiveStep]);
	return (
		<SwipeableViews className="swipeable-views-form-wizard" index={activeStep}>
			{activeStep !== 0 ? (
				<div />
			) : (
				<EmailStep
					handleNext={nextStep}
					isActive={activeStep === 0}
					isCaptchaEnabled={captchaEnabled}
					{...props}
				/>
			)}
			{activeStep !== 1 ? (
				<div />
			) : (
				<PasswordStep
					handleNext={nextStep}
					handlePrev={prevStep}
					isActive={activeStep === 1}
					{...props}
				/>
			)}
			{activeStep !== 2 ? <div /> : <CheckEmailStep {...props} />}
		</SwipeableViews>
	);
};

export default LoginCarousel;
